import styles from "./UpdatePasswordModal.module.scss";
import ChangePasswordForm from "./UpdatePasswordForm";

interface UpdatePasswordModalProps {
  isForgotPasswordPage?: boolean;
  setIsVisible?: (value: boolean) => void;
}

const UpdatePasswordModal: React.FC<UpdatePasswordModalProps> = ({ isForgotPasswordPage, setIsVisible }) => {
  return (
    <div className={styles.root}>
      <div className={styles.root_form}>
        <ChangePasswordForm isForgotPassword={isForgotPasswordPage} setIsVisible={setIsVisible} />
      </div>
    </div>
  );
};

export default UpdatePasswordModal;
